import { sizeTokenOptionsWithDefault, TITLE_LEVEL_OPTIONS } from './token-options.js';
export const ORDER_FIELDS = [
    {
        key: 'order.card.radius',
        label: '주문 정보 상자 모서리 둥글기',
        help: '주문 상세의 구매자·판매자·결제 정보 상자와 판매자 주문 카드 네 모서리의 둥글기입니다.',
        group: '상자',
        type: 'enum',
        defaultValue: 'default',
        options: sizeTokenOptionsWithDefault('radius', '지금 모양 (앱 약 10px · 모바일 웹 12px)'),
    },
    {
        key: 'order.line.labelSize',
        label: '금액 줄 항목 글자 크기',
        help: '주문 금액 줄(주문 수량·소계·배송비·합계와 묶음 배송비 목록)의 왼쪽 항목 이름 글자 크기입니다.',
        group: '금액 줄',
        type: 'size',
        tokenGroup: 'fontSize',
        defaultValue: '$fontSize.sm',
        min: 10,
        max: 24,
    },
    {
        key: 'order.line.valueSize',
        label: '금액 줄 값 글자 크기',
        help: '주문 금액 줄의 오른쪽 값(금액·수량·무료·환불 상태) 글자 크기입니다. 판매자 주문 카드의 합계 금액은 아래 "합계 금액 크기"를 따릅니다.',
        group: '금액 줄',
        type: 'size',
        tokenGroup: 'fontSize',
        defaultValue: '$fontSize.sm',
        min: 10,
        max: 24,
    },
    {
        key: 'order.total.titleLevel',
        label: '합계 금액 크기',
        help: '판매자 주문 카드 맨 아래 합계 금액의 글자 크기(제목 단계)입니다.',
        group: '금액 줄',
        type: 'enum',
        defaultValue: '2',
        options: TITLE_LEVEL_OPTIONS,
    },
    {
        key: 'order.totalDivider.visible',
        label: '합계 위 구분선 보이기',
        help: '주문 금액 줄에서 합계 바로 위에 가로 구분선을 그립니다.',
        group: '구분선',
        type: 'boolean',
        defaultValue: true,
    },
    {
        key: 'order.totalDivider.thickness',
        label: '합계 위 구분선 굵기',
        help: '합계 위 가로 구분선의 두께입니다.',
        group: '구분선',
        type: 'enum',
        defaultValue: 'm',
        options: [
            { value: 's', label: '얇게 (0.5px)' },
            { value: 'm', label: '보통 (1px)' },
            { value: 'l', label: '굵게 (1.5px)' },
            { value: 'xl', label: '아주 굵게 (2px)' },
        ],
    },
    {
        key: 'order.shippingIcon.size',
        label: '배송지 아이콘 크기',
        help: '주문 상세의 배송지 정보(받는 사람·연락처·주소) 왼쪽 위치 아이콘의 크기입니다.',
        group: '아이콘',
        type: 'size',
        tokenGroup: 'dimension',
        defaultValue: '$dimension.s',
        min: 12,
        max: 48,
    },
    {
        key: 'order.copyIcon.size',
        label: '주문번호 복사 아이콘 크기',
        help: '주문번호 옆 복사 아이콘(누르면 주문 정보를 복사)의 크기입니다.',
        group: '아이콘',
        type: 'size',
        tokenGroup: 'dimension',
        defaultValue: '$dimension.xs',
        min: 12,
        max: 48,
    },
];
//# sourceMappingURL=order.js.map